import React, { useEffect, useState } from 'react';
import { useMatchMedia } from '@/src/assets/hooks/useMatchMedia';
import Button from '../../UI/button/Button';
import SearchBar from '../../searchBar/SearchBar';
import Wrapper from "../../UI/wrapper/Wrapper";
import NextImage from '../../UI/nextImage/NextImage';
import Nav from '../../nav/Nav';
import Logo from '../Logo/Logo';
import styles from './Header.module.scss';
import { useClientQueries } from '@/src/assets/hooks/useClientQueries';
import { headerQuery } from '@/src/assets/queries/headerQuery';
import { IHeader } from '@/src/assets/interfaces/headerInterface';
import close from '@/public/close.svg';

const Header = () => {
  const { data }: { data: IHeader | null } = useClientQueries(headerQuery);

  const headerData: IHeader | null = data ? data : null;
  const { isNarrowScreen } = useMatchMedia();

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const [isNavActive, setIsNavActive] = useState(false);
  const [isMobileActive, setMobileActive] = useState<string | null>(null);

  useEffect(() => {

    setMobileActive(null)
    if (isNarrowScreen && isNavActive) {
      document.body.style.cssText = `overflow-y: hidden; position: fixed; height: ${window.innerHeight}px;`;
    } else {
      document.body.style.cssText = "overflow-y: initial; position: initial; height: auto;";
    }

    return () => {
      document.body.style.cssText = "overflow-y: initial; position: initial; height: auto;";
    };
  }, [isNavActive]);

  const headerColor = isNarrowScreen && isSearchOpen && styles['header__color'];

  const handleMobileNav = () => {
    setIsNavActive(!isNavActive);
  }

  return (
      <header className={`${styles.header} ${headerColor}`}>
          <Wrapper className={styles.wrapper}>
            {
              !isSearchOpen
                ?  <div className={styles.burger} onClick={() => handleMobileNav()}>
                        <span className={styles.burger__line}></span>
                        <span className={styles.burger__line}></span>
                    </div>
                :   <button 
                        onClick={toggleSearch} 
                        aria-label='Close'
                        className={styles.close__button}
                    >
                      <NextImage 
                          src={close}
                          alt='Close'
                          width={36}
                          height={36}
                      />
                  </button>
            }
              <Logo 
                  sizes='120px'
                  className={styles.logo}
              />
              <div className={styles.header__center}>
                  {data &&
                      <Nav 
                        data={headerData!}
                        isNavActive={isNavActive}
                        setIsNavActive={setIsNavActive}
                        headerButton={headerData!.headerButton}
                        isMobileActive={isMobileActive}
                        setIsMobileActive={setMobileActive}
                      />}
                  <SearchBar isSearchOpen={isSearchOpen} setIsSearchOpen={setIsSearchOpen}/> 
              </div>
                 
              <Button 
                  className={`${styles.button} btn__green`}
                  ariaLabel='Bonus Codes'
                  buttonUrl={data ? (headerData!.headerButton.buttonUrl ?? undefined) : undefined}
                  target={data ? (headerData!.headerButton.newWindow ?? undefined) : undefined}
                >
                  {data && headerData!.headerButton.buttonText}
              </Button>
          </Wrapper>
      </header>
  )
}

export default Header;
